import { render, staticRenderFns } from "./RedirectDialog.vue?vue&type=template&id=519edde6&scoped=true&"
import script from "./RedirectDialog.vue?vue&type=script&lang=js&"
export * from "./RedirectDialog.vue?vue&type=script&lang=js&"
import style0 from "./RedirectDialog.vue?vue&type=style&index=0&id=519edde6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519edde6",
  null
  
)

export default component.exports